import { isMobileOnly } from 'react-device-detect';

export const useStyles = () => {
  return {
    root: {
      display: 'grid',
      gridTemplateColumns: isMobileOnly ? 'repeat(5, 32px)' : 'repeat(4, 1fr)',
      gridAutoRows: 'max-content',
      gap: 2,
      justifyContent: isMobileOnly ? 'space-between' : 'center',
      height: '100%',
      width: '96%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  };
};
